import domContentLoaded from "dom-content-loaded";
import $ from "jquery";
import "slick-carousel";

// SCSS
import "../scss/nishioPhysical.scss";

domContentLoaded(() => {
  // ページタイトルのスライダーです
  const $slider = $(".js_npSlider");
  $slider.slick({
    arrows: false,
    fade: true,
    // vertical: true,
    dots: false,
    autoplay: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    swipe: false,
  });

  // 回転する写真
  // const container = document.querySelector(".np_loop_list");
  // const targetCount = 24;
  // const angleStep = 180 / targetCount;

  // const currentItems = container.querySelectorAll(".np_loop_item").length;
  // const itemsToAdd = targetCount - currentItems;

  // for (let i = 0; i < itemsToAdd; i++) {
  //   const newItem = document.createElement("div");
  //   newItem.classList.add("np_loop_item");

  //   // 回転角度を計算して適用
  //   const angle = (currentItems + i) * angleStep;
  //   newItem.style.transform = `rotate(${angle}deg)`;

  //   container.appendChild(newItem);
  // }
  const container = document.querySelector(".np_loop_list");
  const targetCount = 24;
  const angleStep = 180 / targetCount;

  let items = container.querySelectorAll(".np_loop_item");
  const currentCount = items.length;

  if (currentCount === 0) {
    console.warn("No .np_loop_item found to clone.");
  } else {
    for (let i = currentCount; i < targetCount; i++) {
      // クローン作成（子要素ごと）
      const clone = items[i % currentCount].cloneNode(true);

      // 回転角度を設定
      const angle = i * angleStep;
      clone.style.transform = `rotate(${angle}deg)`;

      container.appendChild(clone);
    }

    // 既存のものも角度を振り直す
    items = container.querySelectorAll(".np_loop_item");
    items.forEach((item, index) => {
      const angle = index * angleStep;
      item.style.transform = `rotate(${angle}deg)`;
    });
  }
});
